<div class="row">
    <div class="col-auto">
        <ul class="mb-0">
            <li class="">
                <span class="badge badge-secondary">{{companyInfo.companyNm}}</span>에
                공급되고 있는 차량 관리
            </li>
            <li class="">
                그룹을 지정하지 않은 차량은 메인 차량 목록의
                <span class="badge badge-secondary">기타</span>그룹에 표시됩니다
            </li>
        </ul>
    </div>
</div>
<div class="row mt-3">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="검색어"
                [(ngModel)]="searchValue"
                (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickSearch()">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        그룹
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="dtgTeamId"
                (ngModelChange)="changeTeamInfo($event)">
                <option [ngValue]="''" *ngIf="userGroupId <= 100">전체그룹</option>
                <option [ngValue]="'undefined'">미설정</option>
                <option *ngFor="let item of listTeam;"
                    [ngValue]="item.dtgTeamId">
                    {{item.dtgTeamNm}}
                </option>
            </select>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        차량종류
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="dtgCarType"
                (ngModelChange)="changeCarType($event)">
                <option *ngFor="let item of listCarType;"
                    [ngValue]="item.dtgCarType">
                    {{item.dtgCarTypeNm}}
                </option>
            </select>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        사용여부
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="useYn"
                (ngModelChange)="changeUseYn($event)">
                <option [ngValue]="''">전체</option>
                <option [ngValue]="'Y'">Y</option>
                <option [ngValue]="'N'">N</option>
            </select>
        </div>
    </div>
    <div class="col"></div>
    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-success"
            (click)="exportExcel()">
            <i class="fas fa-file-excel"></i>
            <span class="ml-1">엑셀출력</span>
        </button>
    </div>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0">
        <thead class="">
            <th>
                회사이름
            </th>
            <th>
                그룹이름
            </th>
            <th>
                차량번호
            </th>
            <th>
                공급회사이름
            </th>
            <th>
                차량종류
            </th>
            <th>
                단말번호
            </th>
            <th>
                운전자ID
            </th>
            <th>
                운전자이름
            </th>
            <th>
                마지막 수신
            </th>
            <th [hidden]="listType === DtgListType.modal">
                편집
            </th>
        </thead>
        <tbody class="">
            <tr *ngFor="let item of listCar;">
                <td>
                    {{item.extCompanyNm}}
                </td>
                <td>
                    <span [hidden]="!item.dtgTeamNm">{{item.dtgTeamNm}}</span>
                    <span [hidden]="item.dtgTeamNm" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    <span [hidden]="!item.dtgCarNo">{{item.dtgCarNo}}</span>
                    <span [hidden]="item.dtgCarNo" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    {{item.companyNm}}
                </td>
                <td>
                    {{item.dtgCarTypeNm}}
                </td>
                <td>
                    <span [hidden]="listType === DtgListType.modal">{{item.dtgUnitId}}</span>
                    <button type="button" class="btn btn-sm btn-link px-0"
                        [hidden]="listType === DtgListType.list"
                        (click)="clickSelectCar(item)">
                        <span class="">{{item.dtgUnitId}}</span>
                    </button>
                </td>
                <td>
                    <span [hidden]="!item.userId">{{item.userId}}</span>
                    <span [hidden]="item.userId" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    <span [hidden]="!item.userNm">{{item.userNm}}</span>
                    <span [hidden]="item.userNm" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    {{item.updateDt}}
                </td>
                <td [hidden]="listType === DtgListType.modal">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="clickOpenModalCarInfo(DtgActionType.update,item)">
                        <i class="mdi mdi-pen"></i>
                        <span class="ml-1">수정</span>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
</div>